<template>
  <div class="vip-gift-wrapper">
    <div class="vip-gift-container">
      <!-- 加载中 -->
      <div v-if="pageLoading" class="loading-tip">
        <el-card class="tip-card">
          <div class="tip-content">
            <i class="el-icon-loading"></i>
            <p>信息获取中...</p>
          </div>
        </el-card>
      </div>
      
      <!-- 非加载状态下的内容 -->
      <template v-else>
        <!-- 数据源切换（玩心/新主体） - 始终显示在顶部 -->
        <div v-if="yuewanUserInfo && yuewanUserInfo.length > 0" class="data-source-section">
          <el-card class="data-source-card">
            <el-radio-group v-model="dataSource" size="small" @change="handleDataSourceChange">
              <el-radio-button label="wanxin">玩心数据</el-radio-button>
              <el-radio-button label="yuewan">悦玩数据</el-radio-button>
            </el-radio-group>
          </el-card>
        </div>

        <!-- 游戏信息未绑定时的提示 -->
        <div v-if="!isGameBound" class="not-bound-tip">
          <el-card class="tip-card">
            <div class="tip-content">
              <i class="el-icon-warning-outline"></i>
              <p>请前往游戏信息页面绑定后操作</p>
            </div>
          </el-card>
        </div>

        <!-- 游戏信息已绑定时展示内容 -->
        <template v-else>
          <!-- VIP 信息 -->
        <div class="vip-info-section">
          <div class="section-header">
            <h3>VIP 信息</h3>
            <el-tag :type="getVipStatusType(vipInfo.vip_status)" size="small">
              {{ getVipStatusText(vipInfo.vip_status) }}
            </el-tag>
          </div>
          <el-card class="vip-info-card">
            <div class="vip-info-grid">
              <!-- 根据状态展示不同内容 -->
              <!-- 未分配：不展示时间和负责人 -->
              <template v-if="vipInfo.vip_status === 0">
                <!-- 不展示任何内容 -->
              </template>
              <!-- 未接入：展示分配时间和负责人 -->
              <template v-else-if="vipInfo.vip_status === 1">
                <div class="vip-info-item" v-if="vipInfo.assign_time">
                  <span class="label">分配时间：</span>
                  <span class="value">{{ vipInfo.assign_time }}</span>
                </div>
                <div class="vip-info-item" v-if="vipInfo.charge_person">
                  <span class="label">负责人：</span>
                  <span class="value">{{ vipInfo.charge_person }}</span>
                </div>
              </template>
              <!-- 已接入/已出库：展示分配时间、接入时间、负责人 -->
              <template v-else>
                <div class="vip-info-item" v-if="vipInfo.assign_time">
                  <span class="label">分配时间：</span>
                  <span class="value">{{ vipInfo.assign_time }}</span>
                </div>
                <div class="vip-info-item" v-if="vipInfo.join_time">
                  <span class="label">接入时间：</span>
                  <span class="value">{{ vipInfo.join_time }}</span>
                </div>
                <div class="vip-info-item" v-if="vipInfo.charge_person">
                  <span class="label">负责人：</span>
                  <span class="value">{{ vipInfo.charge_person }}</span>
                </div>
              </template>
            </div>
          </el-card>
        </div>

        <!-- VIP 礼包推荐（仅未接入状态不展示） -->
        <div v-if="showGiftRecommend" class="gift-recommend-section">
          <div class="section-header">
            <h3>VIP 礼包推荐</h3>
          </div>
          <el-card class="gift-form-card">
            <!-- 选择游戏 -->
            <div class="form-item">
              <el-select 
                v-model="selectedGame" 
                placeholder="请选择游戏" 
                filterable
                style="width: 100%"
                @change="handleGameChange"
              >
                <el-option 
                  v-for="game in gameOptions" 
                  :key="game.major_id" 
                  :label="game.major_name" 
                  :value="game.major_id"
                ></el-option>
              </el-select>
            </div>
            
            <!-- 选择角色 -->
            <div class="form-item">
              <el-select 
                v-model="selectedRole" 
                placeholder="选择角色（当选择游戏后有值）" 
                filterable
                style="width: 100%"
                :disabled="!selectedGame"
              >
                <el-option 
                  v-for="role in roleOptions" 
                  :key="role.role_id" 
                  :label="`${role.role_name}（${role.role_id}）`" 
                  :value="role.role_id"
                ></el-option>
              </el-select>
            </div>
            
            <!-- 是否查询近7天单日礼包 -->
            <div class="form-item">
              <label class="form-label">是否查询近 7 天单日礼包</label>
              <el-radio-group v-model="queryLast7Days" class="inline-radio-group">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </div>
            
            <!-- 选择查询日期（仅当选择"是"时展示） -->
            <div class="form-item" v-if="queryLast7Days">
              <el-date-picker 
                v-model="queryDate" 
                type="date" 
                placeholder="请选择查询日期"
                style="width: 100%"
                :picker-options="datePickerOptions"
              ></el-date-picker>
            </div>
            
            <!-- 校验提示 -->
            <div class="form-tip" v-if="formValidationTip">
              <span class="tip-text">{{ formValidationTip }}</span>
            </div>
            
            <!-- 查询按钮 -->
            <el-button type="primary" @click="queryGiftList" :loading="giftLoading" style="width: 100%">
              查询
            </el-button>
          </el-card>
          
          <!-- 礼包Tab切换和列表 -->
          <div v-if="giftList.length > 0" class="gift-tabs-section" ref="giftListRef">
            <div class="gift-tabs">
              <el-radio-group v-model="activeGiftTab" size="small">
                <el-radio-button 
                  v-for="(label, key) in giftTabTypes" 
                  :key="key" 
                  :label="key"
                  class="gift-tab-btn"
                >
                  {{ label }}
                  <span v-if="hasGiftData(key)" class="tab-red-dot"></span>
                </el-radio-button>
              </el-radio-group>
            </div>
            
            <!-- 当前Tab充值金额 -->
            <div class="gift-money-info">
              <span class="money-label">{{ giftMoneyLabels[activeGiftTab] }}：</span>
              <span class="money-value">{{ currentTabMoney }}</span>
            </div>
            
            <!-- 礼包列表 -->
            <div class="gift-list">
              <template v-if="currentTabGifts.length > 0">
                <div 
                  v-for="gift in currentTabGifts" 
                  :key="gift.gift_id" 
                  class="gift-item"
                  :class="{ 'gift-item-no-btn': gift.receive_status === 2 }"
                >
                  <div class="gift-info">
                    <div class="gift-name">{{ gift.name }}</div>
                  <div class="gift-detail">
                    {{ giftTabTypes[gift.type] || gift.type }}；金额档位：{{ gift.money }}
                    <span v-if="gift.receive_status !== 2" class="receive-status" :class="getReceiveStatusClass(gift.is_admin_fetch)">
                      ；{{ getReceiveStatusText(gift.is_admin_fetch) }}
                    </span>
                  </div>
                </div>
                <div class="gift-action">
                    <!-- 可领取状态 -->
                    <el-button 
                      v-if="gift.receive_status === 0" 
                      type="primary" 
                      size="mini"
                      @click="handleReceiveGift(gift)"
                    >
                      领取
                    </el-button>
                    <!-- 已领取状态 -->
                    <template v-else-if="gift.receive_status === 1">
                      <el-button type="info" size="mini" disabled>已领取</el-button>
                      <div class="copy-link" @click="handleCopyGiftCode(gift)">复制礼包码</div>
                    </template>
                    <!-- 不可领取状态（不展示按钮） -->
                  </div>
                </div>
              </template>
              <div v-else class="gift-empty">暂无数据</div>
            </div>
          </div>
          
          <!-- 历史单日充值礼包 -->
          <div v-if="queryLast7Days && queryDate && historyGiftList.length > 0" class="history-gift-section">
            <div class="section-header">
              <h3>历史单日充值礼包</h3>
            </div>
            <div class="history-money-info">
              <span class="date-label">{{ formatQueryDate }}当日充值：</span>
              <span class="money-value">{{ historyMoney }}</span>
            </div>
            
            <div class="gift-list">
              <div 
                v-for="gift in historyGiftList" 
                :key="'history-' + gift.gift_id" 
                class="gift-item"
                :class="{ 'gift-item-no-btn': gift.receive_status === 2 }"
              >
                <div class="gift-info">
                  <div class="gift-name">{{ gift.name }}</div>
                  <div class="gift-detail">
                    {{ giftTabTypes[gift.type] || gift.type }}；金额档位：{{ gift.money }}
                    <span v-if="gift.receive_status !== 2" class="receive-status" :class="getReceiveStatusClass(gift.is_admin_fetch)">
                      ；{{ getReceiveStatusText(gift.is_admin_fetch) }}
                    </span>
                  </div>
                </div>
                <div class="gift-action">
                  <!-- 可领取状态 -->
                  <el-button 
                    v-if="gift.receive_status === 0" 
                    type="primary" 
                    size="mini"
                    @click="handleReceiveGift(gift, 1)"
                  >
                    领取
                  </el-button>
                  <!-- 已领取状态 -->
                  <template v-else-if="gift.receive_status === 1">
                    <el-button type="info" size="mini" disabled>已领取</el-button>
                    <div class="copy-link" @click="handleCopyGiftCode(gift, 1)">复制礼包码</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
// import vConsole from 'vconsole';
// new vConsole();
import {
  getUserInfoApi,
  getQwSignatureApi,
  getVipInfoApi,
  getVipGiftListApi,
  receiveVipGiftApi,
  oauthLoginApi,
} from '@/api/vipGiftRecommend';
import {
  getContactUserId,
  setContactUserId,
} from '@/utils/localStorage';

export default {
  name: 'VipGiftRecommend',
  data() {
    return {
      // 企微相关
      userId: '', // 企微外部联系人ID
      contactUserId: '', // 企微客服员工userId（通过OAuth授权获取）
      corpid: 'ww13459a28a657c19a',
      agentid: 1000002,
      
      // 页面加载状态
      pageLoading: true,
      
      // 游戏绑定状态
      isGameBound: false,
      
      // 用户信息
      userInfo: [], // 玩心用户数据
      yuewanUserInfo: [], // 新主体用户数据
      dataSource: 'wanxin', // 数据源切换：'wanxin' 玩心 | 'yuewan' 悦玩
      
      // VIP 信息
      vipInfo: {
        vip_status: 0, // 0未分配 1未接入 2已接入 3已出库
        assign_time: '',
        join_time: '',
        charge_person: '',
        user_id: '', // 用户ID（从 external-vip-info 接口返回）
        vip_id: '', // VIP ID（从 external-vip-info 接口返回）
      },
      vipRoleList: [], // VIP角色列表
      
      // 礼包推荐
      selectedGame: '', // 选择的游戏(major_id)
      selectedRole: '', // 选择的角色ID
      queryLast7Days: false, // 是否查询近7天单日礼包
      queryDate: '', // 查询日期
      activeGiftTab: 1, // 当前礼包Tab (1=日礼包)
      giftList: [], // 礼包列表（按类型分组）
      historyMoney: '', // 历史充值
      historyGiftList: [], // 历史礼包列表
      giftLoading: false, // 礼包加载状态
      
      // 礼包类型映射（type: 1=日礼包 2=周礼包 3=月礼包 4=总充值 5=总充值月礼包）
      giftTabTypes: {
        1: '日礼包',
        2: '周礼包',
        3: '月礼包',
        4: '总充值礼包',
        5: '总充值月礼包'
      },
      // 礼包类型对应的充值字段提示
      giftMoneyLabels: {
        1: '今日充值',
        2: '上周充值',
        3: '本月充值',
        4: '总充值',
        5: '截止上月底总充值'
      },
    };
  },
  computed: {
    // 是否展示礼包推荐（仅未接入状态不展示）
    showGiftRecommend() {
      // vip_status: 0未分配, 1未接入, 2已接入, 3已出库
      return [0, 2, 3].includes(Number(this.vipInfo.vip_status));
    },
    // 游戏选项列表（从vipRoleList中提取不重复的游戏）
    gameOptions() {
      if (!this.vipRoleList || this.vipRoleList.length === 0) return [];
      const gameMap = new Map();
      this.vipRoleList.forEach(role => {
        if (!gameMap.has(role.major_id)) {
          gameMap.set(role.major_id, {
            major_id: role.major_id,
            major_name: role.major_name
          });
        }
      });
      return Array.from(gameMap.values());
    },
    // 角色选项列表（根据选择的游戏筛选）
    roleOptions() {
      if (!this.selectedGame || !this.vipRoleList) return [];
      return this.vipRoleList
        .filter(role => role.major_id === this.selectedGame)
        .sort((a, b) => {
          // 按创角时间倒序
          return new Date(b.role_create_time) - new Date(a.role_create_time);
        });
    },
    // 日期选择器配置（仅可选择近7天）
    datePickerOptions() {
      const today = new Date();
      today.setHours(23, 59, 59, 999);
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 7);
      sevenDaysAgo.setHours(0, 0, 0, 0);
      return {
        disabledDate(time) {
          return time.getTime() > today.getTime() || time.getTime() < sevenDaysAgo.getTime();
        }
      };
    },
    // 当前Tab的礼包列表
    currentTabGifts() {
      // 注意：v-for 遍历对象时 key 会变成字符串，需要转换为数字比较
      const tabType = Number(this.activeGiftTab);
      const typeData = this.giftList.find(item => item.type === tabType);
      return typeData ? typeData.gift_list : [];
    },
    // 当前Tab的充值金额
    currentTabMoney() {
      const tabType = Number(this.activeGiftTab);
      const typeData = this.giftList.find(item => item.type === tabType);
      return typeData ? typeData.money || '0' : '0';
    },
    // 格式化查询日期
    formatQueryDate() {
      if (!this.queryDate) return '';
      return moment(this.queryDate).format('YYYY-MM-DD');
    },
    // 表单校验提示文案
    formValidationTip() {
      if (!this.selectedGame) {
        return '请选择游戏';
      }
      if (!this.selectedRole) {
        return '选择角色后查询推荐礼包';
      }
      if (this.queryLast7Days && !this.queryDate) {
        return '请选择查询日期';
      }
      return '';
    }
  },
  watch: {
    // 监听"是否查询近7天"切换，清空相关数据
    queryLast7Days(newVal) {
      if (!newVal) {
        // 切换为"否"时，清空日期和历史礼包数据
        this.queryDate = '';
        this.historyGiftList = [];
        this.historyMoney = '';
      }
    }
  },
  mounted() {
    const { corpid, agentid } = this.$route.query;
    if (corpid) {
      this.corpid = corpid;
    }
    if (agentid) {
      this.agentid = agentid;
    }
    // 先处理客服授权流程，再加载企微SDK
    this.initContactAuth();
  },
  methods: {
    // ========== 企微客服授权相关 ==========
    /**
     * 初始化客服授权流程
     * 参考文档: https://developer.work.weixin.qq.com/document/path/91023
     * 流程:
     * 1. 检查本地缓存是否有 contactUserId
     * 2. 如果有缓存，直接使用，继续后续流程
     * 3. 如果没有缓存，检查 URL 是否有 code 参数
     *    - 有 code: 用 code 换取 userId（服务端接口）
     *    - 无 code: 跳转到企微授权页面
     */
    async initContactAuth() {
      // 1. 检查本地缓存
      const cachedUserId = getContactUserId();
      if (cachedUserId) {
        console.log('[企微授权] 使用缓存的客服 userId:', cachedUserId);
        this.contactUserId = cachedUserId;
        // 继续后续业务流程
        this.loadScripts();
        return;
      }

      // 2. 检查 URL 是否有 code 参数（授权回调）
      const { code } = this.$route.query;
      if (code) {
        console.log('[企微授权] 检测到授权回调 code:', code);
        try {
          const res = await oauthLoginApi({
            code,
            corpid: this.corpid,
            agentid: this.agentid,
          });
          
          if (res && res.content && res.content.contact_userid) {
            // 服务端返回了 contact_userid，缓存并使用
            this.contactUserId = res.content.contact_userid;
            setContactUserId(res.content.contact_userid);
            console.log('[企微授权] 获取客服 userId 成功:', res.content);
          } else {
            // 服务端未返回 userId
            console.log('[企微授权] 服务端未返回 contact_userid');
          }
          
          // 清理 URL 中的 code 参数，避免刷新页面重复使用
          const query = { ...this.$route.query };
          delete query.code;
          delete query.state;
          this.$router.replace({ query });
        } catch (error) {
          console.error('[企微授权] 获取客服 userId 失败:', error);
        }
        
        // 继续后续业务流程
        this.loadScripts();
        return;
      }

      // 3. 无缓存且无 code，跳转到企微授权页面
      console.log('[企微授权] 无缓存且无 code，跳转授权页面');
      this.redirectToQwAuth();
    },
    
    /**
     * 跳转到企微网页授权页面
     * 使用 snsapi_base 静默授权模式
     */
    redirectToQwAuth() {
      // 构造当前页面 URL 作为回调地址（保留 corpid 和 agentid 参数）
      const currentUrl = window.location.href.split('?')[0];
      const params = new URLSearchParams();
      params.set('corpid', this.corpid);
      params.set('agentid', this.agentid);
      const redirectUri = encodeURIComponent(`${currentUrl}?${params.toString()}`);
      
      // 构造企微授权链接
      // 参考: https://developer.work.weixin.qq.com/document/path/91022
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.corpid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&agentid=${this.agentid}&state=vipGiftRecommend#wechat_redirect`;
      
      console.log('[企微授权] 跳转授权页面:', authUrl);
      window.location.href = authUrl;
    },
    
    // ========== 企微SDK相关 ==========
    loadScripts() {
      const captchaScript = document.createElement('script');
      captchaScript.type = 'text/javascript';
      captchaScript.src = '//wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.0.2.js';
      captchaScript.onload = () => {
        this.wxRegister();
      };
      document.head.appendChild(captchaScript);
    },
    wxRegister() {
      ww.register({
        corpId: this.corpid,
        agentId: this.agentid,
        jsApiList: ['getCurExternalContact', 'getContext'],
        getAgentConfigSignature: async (url) => {
          const res = await getQwSignatureApi({
            url: url,
            corpid: this.corpid,
            agentid: this.agentid,
          });
          const { timestamp, nonce_str, signature } = res.content;
          return { timestamp, nonceStr: nonce_str, signature };
        },
      });
      ww.getCurExternalContact({
        success: (res) => {
          console.log('获取当前客户ID', res.userId);
          this.userId = res.userId;
          // 先获取用户信息，判断游戏是否已绑定
          this.getUserInfo();
        },
        fail(err) {
          console.log('获取当前客户信息失败', err);
        },
      });
    },
    
    // ========== 用户信息相关 ==========
    async getUserInfo() {
      try {
        const res = await getUserInfoApi({
          corpid: this.corpid,
          external_userid: this.userId,
        });
        console.log('获取用户信息结果', res);
        
        if (res && res.content) {
          const content = res.content;
          // 玩心用户数据（过滤掉可能存在的 null 值）
          this.userInfo = (content.user_data_list || []).filter(Boolean);
          // 新主体用户数据（过滤掉可能存在的 null 值）
          this.yuewanUserInfo = (content.yuewan_user_data_list || []).filter(Boolean);
          
          // 判断游戏是否已绑定（有用户数据说明已绑定）
          if (this.userInfo.length > 0 || this.yuewanUserInfo.length > 0) {
            this.isGameBound = true;
            // 获取VIP信息
            console.log('获取VIP信息');
            this.getVipInfo();
          } else {
            this.isGameBound = false;
            this.pageLoading = false;
          }
        } else {
          this.isGameBound = false;
          this.pageLoading = false;
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.isGameBound = false;
        this.pageLoading = false;
      }
    },
    // 数据源切换
    handleDataSourceChange(value) {
      console.log('切换数据源:', value);
      // 清空游戏和角色选择
      this.selectedGame = '';
      this.selectedRole = '';
      // 清空礼包列表和相关查询状态
      this.giftList = [];
      this.historyGiftList = [];
      this.historyMoney = '';
      this.queryLast7Days = false;
      this.queryDate = '';
      this.activeGiftTab = 1;
      // 切换数据源后重新获取VIP信息
      this.getVipInfo();
    },
    
    // ========== VIP 信息相关 ==========
    getVipStatusType(status) {
      switch (Number(status)) {
        case 0: return 'info'; // 未分配
        case 1: return 'warning'; // 未接入
        case 2: return 'success'; // 已接入
        case 3: return ''; // 已出库
        default: return 'info';
      }
    },
    getVipStatusText(status) {
      switch (Number(status)) {
        case 0: return '未分配';
        case 1: return '未接入';
        case 2: return '已接入';
        case 3: return '已出库';
        default: return '未知';
      }
    },
    async getVipInfo() {
      try {
        const res = await getVipInfoApi({
          corpid: this.corpid,
          external_userid: this.userId,
          type: this.dataSource, // 'wanxin' 或 'yuewan'
        });
        console.log('获取VIP信息结果', res);

        if (res && res.content) {
          const content = res.content;
          this.vipInfo = {
            vip_status: Number(content.vip_status), // 转为数字确保类型一致
            assign_time: content.assign_time,
            join_time: content.join_time,
            charge_person: content.charge_person,
            user_id: content.user_id, // 用户ID
            vip_id: content.vip_id, // VIP ID
          };
          this.vipRoleList = content.role_list || [];
          
          // 判断游戏是否已绑定：需要同时满足 role_list 有数据且 user_id/vip_id 不为 null
          const hasRoleList = this.vipRoleList.length > 0;
          const hasValidIds = content.user_id != null && content.vip_id != null;
          this.isGameBound = hasRoleList && hasValidIds;
          
          // 如果游戏已绑定且有角色列表，默认选择第一个游戏和角色
          if (this.isGameBound) {
            this.selectedGame = this.vipRoleList[0].major_id;
            this.handleGameChange(this.selectedGame);
          }
        } else {
          this.isGameBound = false;
        }
      } catch (error) {
        console.error('获取VIP信息失败:', error);
        this.isGameBound = false;
      } finally {
        this.pageLoading = false;
      }
    },
    
    // ========== 礼包推荐相关 ==========
    handleGameChange(majorId) {
      this.selectedRole = '';
      const roles = this.vipRoleList.filter(r => r.major_id === majorId);
      if (roles.length > 0) {
        // 按创角时间倒序，默认选第一个
        const sortedRoles = roles.sort((a, b) => {
          return new Date(b.role_create_time) - new Date(a.role_create_time);
        });
        this.selectedRole = sortedRoles[0].role_id;
      }
    },
    hasGiftData(tabKey) {
      // 注意：v-for 遍历对象时 tabKey 会变成字符串，需要转换为数字比较
      const tabType = Number(tabKey);
      const typeData = this.giftList.find(item => item.type === tabType);
      return typeData && typeData.gift_list && typeData.gift_list.length > 0;
    },
    async queryGiftList() {
      // 校验必填项
      if (!this.selectedGame) {
        this.$message.warning('请选择游戏');
        return;
      }
      if (!this.selectedRole) {
        this.$message.warning('请选择角色后查询推荐礼包');
        return;
      }
      if (this.queryLast7Days && !this.queryDate) {
        this.$message.warning('请选择查询日期');
        return;
      }
      
      this.giftLoading = true;
      try {
        const params = {
          corpid: this.corpid,
          external_userid: this.userId,
          role_id: this.selectedRole,
          major_id: this.selectedGame,
          type: this.dataSource, // 'wanxin' 或 'yuewan'
          user_id: this.vipInfo.user_id, // 用户ID
          vip_id: this.vipInfo.vip_id, // VIP ID
        };
        
        if (this.queryLast7Days && this.queryDate) {
          params.check_date = moment(this.queryDate).format('YYYY-MM-DD');
        }
        
        const res = await getVipGiftListApi(params);
        console.log('获取礼包列表结果', JSON.stringify(res));
        
        if (res && res.content) {
          const content = res.content;
          this.giftList = content.today_gift_list || [];
          
          if (this.queryLast7Days && this.queryDate) {
            this.historyMoney = content.history_money || '0';
            this.historyGiftList = content.history_gift_list || [];
          } else {
            this.historyMoney = '';
            this.historyGiftList = [];
          }
        }
      } catch (error) {
        console.error('获取礼包列表失败:', error);
        this.$message.error('获取礼包列表失败');
      } finally {
        this.giftLoading = false;
      }
    },
    getReceiveStatusClass(status) {
      // is_admin_fetch: 0=主管未领取 1=主管已领取
      return status === 1 ? 'status-received' : 'status-available';
    },
    getReceiveStatusText(status) {
      // is_admin_fetch: 0=主管未领取 1=主管已领取
      return status === 1 ? '主管已领取' : '主管未领取';
    },
    /**
     * 显示礼包码弹窗
     */
    showGiftCodeDialog(copyText) {
      this.$alert(
        `<div style="word-break:break-all;white-space:pre-wrap;max-height:300px;overflow:auto;padding:12px;background:#f5f5f5;border-radius:4px;font-family:monospace;font-size:14px;line-height:1.6;user-select:text;">${copyText}</div>`,
        '礼包码',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭',
          customClass: 'gift-code-dialog',
          callback: () => {}
        }
      );
    },
    /**
     * 调用领取礼包接口并处理返回结果
     * @param {Object} gift - 礼包对象
     * @param {Boolean} isReceive - 是否是领取操作（true=领取，false=复制）
     * @param {Number} giftType - 礼包类型（1=日礼包 2=周礼包 3=月礼包 4=总充值 5=总充值月礼包）
     */
    async callReceiveGiftApi(gift, isReceive = true, giftType = null) {
      try {
        const res = await receiveVipGiftApi({
          corpid: this.corpid,
          external_userid: this.userId,
          role_id: this.selectedRole,
          major_id: this.selectedGame,
          gift_id: gift.gift_id,
          type: this.dataSource,
          contact_userid: this.contactUserId,
          user_id: this.vipInfo.user_id,
          vip_id: this.vipInfo.vip_id,
          gift_type: giftType || this.activeGiftTab, // 使用传入的 giftType 或当前 activeGiftTab
          receive_status: gift.receive_status,
        });
        
        console.log(isReceive ? '领取礼包结果' : '复制礼包码结果', res);
        
        if (res && res.ret === 1) {
          // 获取礼包码和礼包内容（过滤 null 值）
          const giftCode = res.content.gift_code || '';
          const giftContent = res.content.content|| '';
          // 组合礼包码和礼包内容（只有 giftContent 有值时才拼接）
          const copyText = giftContent.trim() ? `${giftCode}\n${giftContent}` : giftCode;
          
          if (copyText) {
            // 显示弹窗展示礼包码，用户可手动长按复制
            this.showGiftCodeDialog(copyText);
            
            // 如果是领取操作，重新获取礼包列表以更新关联状态
            if (isReceive) {
              this.queryGiftList();
            }
            
            return true;
          } else {
            this.$message.warning('暂无礼包码');
            return false;
          }
        } else {
          this.$message.error((res && res.message) || '礼包码已发放完');
          return false;
        }
      } catch (error) {
        console.error(isReceive ? '领取礼包失败' : '复制礼包码失败', error);
      }
    },
    /**
     * 领取礼包
     * @param {Object} gift - 礼包对象
     * @param {Number} giftType - 礼包类型（1=日礼包 2=周礼包 3=月礼包 4=总充值 5=总充值月礼包）
     */
    async handleReceiveGift(gift, giftType = null) {
      await this.callReceiveGiftApi(gift, true, giftType);
    },
    /**
     * 复制礼包码
     * @param {Object} gift - 礼包对象
     * @param {Number} giftType - 礼包类型（1=日礼包 2=周礼包 3=月礼包 4=总充值 5=总充值月礼包）
     */
    async handleCopyGiftCode(gift, giftType = null) {
      await this.callReceiveGiftApi(gift, false, giftType);
    },
  },
};
</script>

<style lang="scss" scoped>
.vip-gift-wrapper {
  width: 360px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.vip-gift-container {
  padding: 15px;
  background-color: #f5f7fa;
  min-height: 100%;

  // 加载中提示
  .loading-tip {
    .tip-card {
      border-radius: 8px;
      
      .tip-content {
        text-align: center;
        padding: 30px 20px;
        
        i {
          font-size: 48px;
          color: #409eff;
          margin-bottom: 15px;
        }
        
        p {
          font-size: 14px;
          color: #606266;
          margin: 0;
        }
      }
    }
  }

  // 未绑定提示
  .not-bound-tip {
    .tip-card {
      border-radius: 8px;
      
      .tip-content {
        text-align: center;
        padding: 30px 20px;
        
        i {
          font-size: 48px;
          color: #e6a23c;
          margin-bottom: 15px;
        }
        
        p {
          font-size: 14px;
          color: #606266;
          margin: 0;
        }
      }
    }
  }

  // 通用区块头部
  .section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    
    h3 {
      font-size: 18px;
      font-weight: bold;
      color: #303133;
      margin: 0;
    }
  }

  // 数据源切换区域
  .data-source-section {
    margin-bottom: 15px;
    
    .data-source-card {
      border-radius: 8px;
      
      ::v-deep .el-radio-group {
        display: flex;
        width: 100%;
        
        .el-radio-button {
          flex: 1;
          
          .el-radio-button__inner {
            width: 100%;
            border-radius: 0;
            border-left-width: 0;
          }
          
          &:first-child .el-radio-button__inner {
            border-left-width: 1px;
            border-radius: 4px 0 0 4px;
          }
          
          &:last-child .el-radio-button__inner {
            border-radius: 0 4px 4px 0;
          }
        }
      }
    }
  }

  // VIP 信息区域
  .vip-info-section {
    margin-bottom: 15px;
    
    .vip-info-card {
      border-radius: 8px;
      border-left: 4px solid #409eff;
      
      .vip-info-grid {
        display: flex;
        flex-direction: column;
        gap: 8px;
        
        .vip-info-item {
          display: flex;
          align-items: center;
          
          .label {
            color: #606266;
            font-size: 13px;
            min-width: 80px;
          }
          
          .value {
            color: #303133;
            font-size: 13px;
          }
        }
      }
    }
  }

  // 礼包推荐区域
  .gift-recommend-section {
    margin-bottom: 15px;
    
    .gift-form-card {
      border-radius: 8px;
      
      .form-item {
        margin-bottom: 12px;
        
        .form-label {
          display: block;
          font-size: 14px;
          color: #606266;
          margin-bottom: 8px;
        }
        
        .inline-radio-group {
          display: flex;
          gap: 20px;
        }
      }
      
      .form-tip {
        margin-bottom: 12px;
        
        .tip-text {
          color: #e6a23c;
          font-size: 13px;
        }
      }
    }
    
    // 礼包Tab区域
    .gift-tabs-section {
      margin-top: 15px;
      background: #fff;
      border-radius: 8px;
      padding: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      
      .gift-tabs {
        margin-bottom: 12px;
        overflow-x: auto;
        
        .el-radio-group {
          display: flex;
          flex-wrap: nowrap;
        }
        
        .gift-tab-btn {
          position: relative;
          
          .tab-red-dot {
            position: absolute;
            top: 2px;
            right: 2px;
            width: 6px;
            height: 6px;
            background: #f56c6c;
            border-radius: 50%;
          }
        }
      }
      
      .gift-money-info {
        margin-bottom: 12px;
        padding: 8px 12px;
        background: #f0f9ff;
        border-radius: 4px;
        
        .money-label {
          color: #409eff;
          font-size: 13px;
        }
        
        .money-value {
          color: #409eff;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    
    // 礼包列表
    .gift-list {
      .gift-item {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 12px;
        margin-bottom: 10px;
        background: #fafafa;
        border-radius: 6px;
        border: 1px solid #ebeef5;
        
        &.gift-item-no-btn {
          background: #f5f5f5;
        }
        
        .gift-info {
          flex: 1;
          min-width: 0;
          
          .gift-name {
            font-size: 14px;
            font-weight: 500;
            color: #303133;
            margin-bottom: 6px;
          }
          
          .gift-detail {
            font-size: 12px;
            color: #909399;
            line-height: 1.5;
            
            .receive-status {
              &.status-received {
                color: #909399;
              }
              
              &.status-available {
                color: #67c23a;
              }
            }
          }
        }
        
        .gift-action {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 6px;
          margin-left: 10px;
          
          .copy-link {
            color: #409eff;
            font-size: 12px;
            cursor: pointer;
            
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      
      .gift-empty {
        text-align: center;
        padding: 20px;
        color: #909399;
        font-size: 13px;
      }
    }
    
    // 历史单日礼包区域
    .history-gift-section {
      margin-top: 15px;
      background: #fff;
      border-radius: 8px;
      padding: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      
      .section-header {
        margin-bottom: 12px;
      }
      
      .history-money-info {
        margin-bottom: 12px;
        padding: 8px 12px;
        background: #fff7e6;
        border-radius: 4px;
        
        .date-label {
          color: #e6a23c;
          font-size: 13px;
        }
        
        .money-value {
          color: #e6a23c;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>

<!-- 礼包码弹框全局样式 -->
<style>
.gift-code-dialog {
  width: 90% !important;
  max-width: 400px !important;
  margin: 0 auto !important;
}
.gift-code-dialog .el-message-box__message {
  padding: 0;
}
</style>
